<template>
    <v-tooltip bottom v-if="$store.getters.isAuthenticated">
        <template v-slot:activator="{ on: tooltip }">
            <v-btn icon color="error darken-1" v-on="tooltip" @click="logout()">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </template>
        <span>{{ $t("message.LogOut") }}</span>
    </v-tooltip>
    <v-btn v-else text color="success" @click="logout()">
        <span>Login</span>
        <v-icon>mdi-login</v-icon>
    </v-btn>
</template>

<script>
export default {
    methods: {
        logout() {
            this.$store.dispatch("logout");
        },
    },
};
</script>
